import React from 'react';
import { useTranslation } from 'react-i18next';

import { FormStyled } from '@modules/layout/styled';
import { Table, TableCell, TableCellType, TableRow } from '@modules/layout/organisms';

import type { LapEntity } from '@modules/lap/entities';
import { DownloadCertificate } from '@modules/schools/moleculas';

type SchoolLapsTableStatsProps = {
    laps: (LapEntity | null)[];
    schoolId: string;
};

const columns: TableCellType[] = [
    {
        id: 'course',
        label: 'common:table.labels.course',
        sortable: false,
    },
    {
        id: 'name',
        label: 'common:table.labels.lap_dates',
        sortable: false,
    },
];

const SchoolLapsTableStats = (props: SchoolLapsTableStatsProps): React.ReactElement => {
    const { laps, schoolId } = props;

    const { t } = useTranslation(['common']);

    return (
        <>
            <FormStyled.FormColumnTitle>{t('common:forms.titles.laps')}</FormStyled.FormColumnTitle>

            <DownloadCertificate schoolId={schoolId} />

            <Table
                disabledPagination
                id='school-laps-table'
                columns={columns}
                total={{
                    title: [
                        t('common:blocks.laps_summary.one', { summary: '%d' }),
                        t('common:blocks.laps_summary.some', { summary: '%d' }),
                        t('common:blocks.laps_summary.multiple', { summary: '%d' }),
                    ],
                    value: laps.length,
                }}
            >
                {laps.map(lap => (
                    <TableRow key={lap?.id}>
                        <TableCell>{lap?.course.name}</TableCell>
                        <TableCell>{lap?.name}</TableCell>
                    </TableRow>
                ))}
            </Table>
        </>
    );
};

export { SchoolLapsTableStats };
